import React from 'react';
import { Breadcrumb as MagmaBreadcrumb, BreadcrumbItem } from 'react-magma-dom';
import { StyledBreadcrumbItem } from '../Styled/StyledBreadcrumb';

interface IBreadcrumbItem {
  title: string;
  to: string;
}

interface IBreadcrumb {
  items: IBreadcrumbItem[];
  lastItem: string;
}

export const Breadcrumb = (props: IBreadcrumb): JSX.Element => {
  const { items, lastItem } = props;

  return (
    <MagmaBreadcrumb>
      {items.map((item: IBreadcrumbItem, index: number) => {
        return (
          <StyledBreadcrumbItem key={index} to={item.to}>
            {item.title}
          </StyledBreadcrumbItem>
        );
      })}
      <BreadcrumbItem>{lastItem}</BreadcrumbItem>
    </MagmaBreadcrumb>
  );
};
